import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'procure-resize-handler',
  template: '',
  styleUrl: './resize-handler.component.scss',
  host: {
    '[class]': 'placement()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ResizeHandler {
  readonly placement = input.required<'left' | 'right'>();
}
